import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

let cachedCompanyId: string | null = null;
let cachedUserId: string | null = null;

export const useCompanyId = () => {
  const { user } = useAuth();
  const [companyId, setCompanyId] = useState<string | null>(
    user?.id === cachedUserId ? cachedCompanyId : null
  );

  useEffect(() => {
    if (!user) {
      setCompanyId(null);
      return;
    }
    if (user.id === cachedUserId && cachedCompanyId) {
      setCompanyId(cachedCompanyId);
      return;
    }
    supabase
      .from('profiles')
      .select('company_id')
      .eq('id', user.id)
      .maybeSingle()
      .then(({ data }) => {
        if (data?.company_id) {
          cachedCompanyId = data.company_id;
          cachedUserId = user.id;
          setCompanyId(data.company_id);
        }
      });
  }, [user?.id]);

  return companyId;
};
